module.exports = __webpack_public_path__ + "static/media/banner.ed94a08a.png";